import { hmplusLimitedReleasesListConstants } from "../_redux-constants";

export function hmplusLimitedReleasesListReducer(
  state = {
    hmplusLimitedReleasesListLoading: false,
    hmplusLimitedReleasesListData: null,
    hmplusLimitedReleasesListError: null,
  },
  action
) {
  switch (action.type) {
    case hmplusLimitedReleasesListConstants.HMPLUS_LIMITED_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        hmplusLimitedReleasesListLoading: true,
        hmplusLimitedReleasesListData: null,
        hmplusLimitedReleasesListError: null,
      });
    case hmplusLimitedReleasesListConstants.HMPLUS_LIMITED_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        hmplusLimitedReleasesListLoading: false,
        hmplusLimitedReleasesListData: action.data,
      });
    case hmplusLimitedReleasesListConstants.HMPLUS_LIMITED_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        hmplusLimitedReleasesListLoading: false,
        hmplusLimitedReleasesListData: null,
        hmplusLimitedReleasesListError: action.error,
      });
    default:
      return state;
  }
}
